<template>
  <div class="em-qrcode">
    <el-dialog
      title="邀请二维码"
      custom-class="dialog-style"
      :visible.sync="visible"
      width="40%"
      center
      @open="showQRCode"
    >
      <div class="em-qrcode-panel">
        <!--canvas会自动将这里渲染成二维码-->
        <div id="qrcode" ref="qrcode"></div>
        <span slot="footer" class="dialog-footer">
           <common-button @click="downloadQRCode" type="text">点击下载二维码</common-button>
        </span>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import QRCode from "qrcodejs2";

export default {
  components: {QRCode},
  data() {
    return {
      visible: false,
      qrcodeObj: null,
    };
  },

  props: {
    item: {
      type: Object,
      default: function () {
        return {}
      }
    },

    value: {
      type: Boolean,
      default: false,
    },

  },

  watch: {
    value(newVal) {
      this.visible = newVal
    },

    //修改传入的值(实现双向绑定)
    visible(newVal) {
      this.$emit('input', newVal)
    }
  },

  methods: {

    /**
     * @description 生成二维码
     * @param  {number} qWidth  宽度px
     * @param  {number} qHeight  高度px
     * @param  {string} qText  二维码内容（跳转连接）
     * @param  {string} qRender 渲染方式（有两种方式 table和canvas，默认是canvas）
     */
    qrcode(qWidth, qHeight, qText, qRender) {
      this.qrcodeObj = new QRCode("qrcode", {
        width: qWidth,
        height: qHeight,
        text: qText,
        render: qRender
      });

    },

    /**
     * @description 遮罩打开的回调 点击显示二维码
     */
    showQRCode() {
      //调用函数生成二维码
      this.$nextTick(function () {
        //二维码初始化 点击一次添加一个二维码
        this.$refs.qrcode.innerHTML = "";
        this.qrcode(124, 124, this.item.link, "canvas");
      });
    },

    downloadQRCode() {
      const nodeList = Array.prototype.slice.call(this.qrcodeObj._el.children)
      const img = nodeList.find((item) => item.nodeName.toUpperCase() === 'IMG')	// 选出图片类型
      // 构建画布
      let canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      canvas.getContext('2d').drawImage(img, 0, 0);
      // 构造url
      let url = canvas.toDataURL('image/png');
      let element = document.createElement('a');
      document.body.appendChild(element);
      element.setAttribute('href', url);
      element.setAttribute('download', `${this.item.link}-二维码.png`);
      element.click();
      element.remove();
    },

  }
};
</script>

<style scoped>

.em-qrcode {
  position: fixed;
  right: 17px;
  top: 20px;
  width: auto;
  background-color: #4157ff;
  z-index: 3000;
  color: #ffffff;
}

.share-QR-code :hover {
  color: #eef;
}

.link-style {
  color: #4157ff;
  font-size: 12px;
}

#qrcode > img {
  margin: 0 auto;
}

.em-qrcode-panel {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.dialog-footer {
  margin: 20px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/uCenter/QRCode.vue